/* eslint-disable no-plusplus, no-param-reassign, func-names, @typescript-eslint/explicit-function-return-type */

function sortByPonyfill(arr, func) {
  for (let i = arr.length; i; ) {
    const o = arr[--i];
    arr[i] = [].concat(func.call(o, o, i), o);
  }
  arr.sort(function (a, b) {
    for (let j = 0, len = a.length; j < len; ++j) {
      if (a[j] !== b[j]) return a[j] < b[j] ? -1 : 1;
    }
    return 0;
  });
  for (let k = arr.length; k; ) {
    arr[--k] = arr[k][arr[k].length - 1];
  }
  return arr;
}

module.exports.sortByPonyfill = sortByPonyfill;
